var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1F5F3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0cfce",
    stroke: "#d0cfce",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m10.14 63.05v-31.95h51.73v31.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9a",
    stroke: "#9b9b9a",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m61.35 37-26.34 26.05h10.23l16.11-26.05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.17,
    y: 36.99,
    width: 27.87,
    height: 3.752,
    fill: "#d0cfce"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.1 31.34 16.17 5.836 9.927-22.72-16.38-6.695z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9a",
    stroke: "#9b9b9a",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m45.24 63.05h16.62l-0.5146-26.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9b9b9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m21.97 38.89h28.18"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(-7.271 -7.921) scale(1.202)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.664,
    points: "42.41 32.46 57.51 32.46 57.51 57.37"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-7.271 -7.921) scale(1.202)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.664,
    d: "m14.48 57.37v-24.91h11.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(-7.271 -7.921) scale(1.202)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.664,
    points: "37.05 37.24 25.83 32.64 34.14 12.37 48.05 18.07 40.25 37.09"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.91,
    x2: 50.1,
    y1: 36.92,
    y2: 36.92,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F5F3);
export default __webpack_public_path__ + "static/media/1F5F3.391adcdc5c649310b93cc60f3a72ca59.svg";
export { ForwardRef as ReactComponent };